/* global Swiper */

document.addEventListener("DOMContentLoaded", () => {
    const sliders = document.querySelectorAll(".js-products-carousel-swiper");

    sliders.forEach(() => {
        new Swiper(".js-products-carousel-swiper", {
            slidesPerView: 2,
            spaceBetween: 16,
            navigation: {
                nextEl: ".swiper-button--next",
                prevEl: ".swiper-button--prev",
            },
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            breakpoints: {
                576: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 4,
                },
                991: {
                    slidesPerView: 5,
                },
                1200: {
                    slidesPerView: 6,
                },
            },
        });
    });
});
